import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { IDarkTheme } from "styles/darkTheme";

export const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    subLinkSelected: {
      color: theme.colors.secondary.secondary_50,
      fontSize: theme.fontSize.bodyText_1,
      fontFamily: theme.fontFamily.montserrat,
      opacity: "100%",
      fontWeight: theme.fontWeight.bold,
      verticalAlign: "top",
      "@media (max-width: 1300px)": {
        fontSize: theme.fontSize.bodyText_3
      }
    }
  })
);
